(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yds-evie-gallery"] && !Shopify.designMode) return;
  try {
    (()=>{if(window.ydsEvieGalleryV2)return;window.ydsEvieGalleryV2=true;const show=button=>{const gallery=button.closest('[data-evie-gallery]');gallery.querySelectorAll('[data-evie-panel]').forEach(panel=>panel.hidden=panel.dataset.eviePanel!==button.dataset.evieView);gallery.querySelectorAll('[data-evie-view]').forEach(control=>control.setAttribute('aria-pressed',String(control===button)));};document.addEventListener('click',event=>{const button=event.target.closest('[data-evie-view]');if(button)show(button);});document.addEventListener('change',event=>{const gallery=event.target.closest('.yds-evie-product')?.querySelector('[data-evie-tree]');if(!gallery)return;const value=event.target.value;if(['Red','Green','Blue'].includes(value))gallery.dataset.evieColour=value;else if(value.includes('1.7m')||value.includes('60cm'))gallery.dataset.evieSize=value;else return;const index=Math.max(0,['Red','Green','Blue'].indexOf(gallery.dataset.evieColour))+(gallery.dataset.evieSize.includes('1.7')?3:0);const button=gallery.querySelector('[data-evie-view="'+index+'"]');if(button)show(button);});document.addEventListener('keydown',event=>{const button=event.target.closest('[data-evie-view]');if(!button||!['ArrowRight','ArrowLeft','ArrowDown','ArrowUp','Home','End'].includes(event.key))return;const items=[...button.closest('[data-evie-gallery]').querySelectorAll('[data-evie-view]')];const i=items.indexOf(button);let next=event.key==='Home'?0:event.key==='End'?items.length-1:(i+(['ArrowRight','ArrowDown'].includes(event.key)?1:-1)+items.length)%items.length;event.preventDefault();items[next].focus();show(items[next]);});})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yds-gift-voucher-personalisation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-voucher-personalisation')) {
    customElements.define(
      'gift-voucher-personalisation',
      class GiftVoucherPersonalisation extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          const message = this.querySelector('[data-voucher-message]');
          const counter = this.querySelector('[data-voucher-message-count]');
          const propertyFields = this.querySelectorAll('[name^="properties["]');

          if (!message || !counter) return;

          const updateCounter = () => {
            counter.textContent = message.value.length + ' / ' + message.maxLength;
          };

          message.addEventListener('input', updateCounter);

          const form = document.getElementById(message.getAttribute('form'));
          if (form) {
            form.addEventListener('formdata', (event) => {
              propertyFields.forEach((field) => {
                if (field.value.trim() === '') {
                  event.formData.delete(field.name);
                }
              });
            });
          }

          updateCounter();
          this.dataset.initialized = 'true';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yds-mobile-navigation"] && !Shopify.designMode) return;
  try {
    /* YDS mobile navigation v7. Independent accordions; native details work without JavaScript. */
(() => {
  const activeRoots = new WeakMap();
  const selector = '[data-yds-mobile-nav-version="7"]';

  const init = root => {
    if (!root || activeRoots.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    const drawer = root.closest('#header-menu');
    const categories = [...root.querySelectorAll('[data-yds-mobile-category]')];
    drawer?.addEventListener('theme:drawer:open', () => {
      categories.filter(category => category.open).forEach(category => {
        const badge = category.querySelector('a[href="/collections/illustrated-new-zealand-wall-decals"] .yds-ripple-link__new');
        if (!badge) return;
        badge.style.animation = 'none';
        void badge.offsetWidth;
        badge.style.removeProperty('animation');
      });
    }, { signal });
    categories.forEach(category => {
      category.addEventListener('toggle', () => {
        const badge = category.querySelector('a[href="/collections/illustrated-new-zealand-wall-decals"] .yds-ripple-link__new');
        if (badge) {
          badge.style.animation = 'none';
          void badge.offsetWidth;
          if (category.open) badge.style.removeProperty('animation');
        }
        if (!category.open) return;
        categories.forEach(other => {
          if (other !== category && other.open) other.open = false;
        });
      }, { signal });
    });

    const commercial = root.querySelector('[data-yds-commercial]');
    if (!drawer || !commercial) {
      activeRoots.set(root, () => controller.abort());
      return;
    }
    const summary = commercial.querySelector('summary');
    const panel = commercial.querySelector('.yds-mobile-nav__commercial-panel');
    const scroller = drawer.querySelector('[data-drawer-scrolls]');
    const mobile = window.matchMedia('(max-width: 767px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let isOpen = false;
    let animation = null;
    let suppressEscapeKeyup = false;
    let scrollFrame = 0;

    const setExpanded = open => {
      summary.setAttribute('aria-expanded', String(open));
    };

    const bringIntoView = () => {
      if (!scroller) return;
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        if (!isOpen || !mobile.matches) return;
        const offset = summary.getBoundingClientRect().top - scroller.getBoundingClientRect().top - 12;
        scroller.scrollTo({
          top: Math.max(0, scroller.scrollTop + offset),
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
      });
    };

    const setOpen = (open, options = {}) => {
      const next = Boolean(open && mobile.matches);
      const wasOpen = commercial.open;
      const startHeight = wasOpen ? panel.getBoundingClientRect().height : 0;
      const startOpacity = wasOpen ? Number(getComputedStyle(panel).opacity) : 0;
      if (animation) {
        animation.cancel();
        animation = null;
      }
      cancelAnimationFrame(scrollFrame);
      isOpen = next;
      setExpanded(next);
      if (options.focus) summary.focus({ preventScroll: true });
      // A closing panel must not leave its links in the keyboard tab order.
      panel.toggleAttribute('inert', !next);
      const animate = options.animate !== false && !reducedMotion.matches && typeof panel.animate === 'function';
      if (!animate || (!wasOpen && !next)) {
        commercial.open = next;
        if (next && options.scroll) bringIntoView();
        return;
      }
      // Keep native details open while the panel grows or collapses, then remove open.
      commercial.open = true;
      const endHeight = next ? panel.scrollHeight : 0;
      animation = panel.animate([
        { height: `${startHeight}px`, opacity: startOpacity, transform: wasOpen ? 'translateY(0)' : 'translateY(-5px)' },
        { height: `${endHeight}px`, opacity: next ? 1 : 0, transform: next ? 'translateY(0)' : 'translateY(-4px)' }
      ], { duration: next ? 360 : 260, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' });
      const currentAnimation = animation;
      currentAnimation.onfinish = () => {
        if (animation !== currentAnimation) return;
        commercial.open = isOpen;
        currentAnimation.cancel();
        animation = null;
      };
      if (next && options.scroll) bringIntoView();
    };

    summary.addEventListener('click', event => {
      if (!mobile.matches) return;
      event.preventDefault();
      setOpen(!isOpen, { scroll: !isOpen });
    }, { signal });

    // Native/external details changes (including browser find-in-page) stay in sync.
    commercial.addEventListener('toggle', () => {
      if (animation || commercial.open === isOpen) return;
      isOpen = commercial.open && mobile.matches;
      setExpanded(isOpen);
      panel.toggleAttribute('inert', !isOpen);
    }, { signal });

    // Escape closes this accordion first; Tab can continue to every other menu button.
    drawer.addEventListener('keydown', event => {
      if (!isOpen || event.key !== 'Escape') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressEscapeKeyup = true;
      setOpen(false, { focus: true });
    }, { capture: true, signal });

    // Pipeline's drawer closes on keyup; consume the Escape used for this submenu.
    drawer.addEventListener('keyup', event => {
      if (event.key === 'Escape' && suppressEscapeKeyup) {
        event.preventDefault();
        event.stopImmediatePropagation();
        suppressEscapeKeyup = false;
      }
    }, { capture: true, signal });

    const reset = () => setOpen(false, { animate: false });
    drawer.addEventListener('theme:drawer:close', reset, { signal });
    drawer.addEventListener('theme:drawer:open', reset, { signal });
    const drawerObserver = new MutationObserver(() => {
      if (isOpen && (!drawer.classList.contains('drawer--visible') || drawer.classList.contains('display-none'))) reset();
    });
    drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    const onViewportChange = () => { if (!mobile.matches) reset(); };
    if (mobile.addEventListener) mobile.addEventListener('change', onViewportChange);
    else mobile.addListener(onViewportChange);
    window.addEventListener('pageshow', reset, { signal });
    reset();

    activeRoots.set(root, () => {
      reset();
      controller.abort();
      drawerObserver.disconnect();
      cancelAnimationFrame(scrollFrame);
      if (mobile.removeEventListener) mobile.removeEventListener('change', onViewportChange);
      else mobile.removeListener(onViewportChange);
      activeRoots.delete(root);
    });
  };

  const scan = scope => {
    if (scope.matches?.(selector)) init(scope);
    scope.querySelectorAll?.(selector).forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll?.(selector).forEach(root => activeRoots.get(root)?.());
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yds-mural-promo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yds-mural-demo')) {
  customElements.define('yds-mural-demo', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.video = this.querySelector('video');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.onUpdate = () => this.update();
      this.onPlaying = () => {
        if (this.motion.matches || !this.visible || document.hidden || this.completed) {
          this.video.pause();
          return;
        }
        this.classList.add('is-video-ready');
      };
      this.onEnded = () => {
        this.completed = true;
        this.classList.remove('is-video-ready');
      };
      this.onError = () => this.fallback();
      this.video.addEventListener('playing', this.onPlaying);
      this.video.addEventListener('ended', this.onEnded);
      this.video.addEventListener('error', this.onError);
      this.motion.addEventListener('change', this.onUpdate);
      document.addEventListener('visibilitychange', this.onUpdate);
      if (!('IntersectionObserver' in window) || !this.video.canPlayType('video/mp4')) return;
      this.visibleObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].intersectionRatio >= 0.75;
        this.update();
      }, {threshold: [0, 0.75]});
      this.visibleObserver.observe(this);
    }
    fallback() {
      this.failed = true;
      this.video.pause();
      this.classList.remove('is-video-ready');
    }
    update() {
      if (this.motion.matches || navigator.connection?.saveData) {
        this.video.pause();
        if (this.video.hasAttribute('src')) {
          this.video.removeAttribute('src');
          this.video.load();
        }
        this.classList.remove('is-video-ready');
        return;
      }
      if (this.failed || this.completed) return;
      if (!this.visible || document.hidden) {
        this.video.pause();
        return;
      }
      if (!this.video.hasAttribute('src')) {
        this.video.muted = true;
        this.video.src = this.video.dataset.src;
        this.video.load();
      }
      if (this.pending || !this.video.paused) return;
      this.pending = true;
      this.video.play().catch(error => {
        if (error.name !== 'AbortError') this.fallback();
      }).finally(() => { this.pending = false; });
    }
    disconnectedCallback() {
      this.video.pause();
      this.visibleObserver?.disconnect();
      this.video.removeEventListener('playing', this.onPlaying);
      this.video.removeEventListener('ended', this.onEnded);
      this.video.removeEventListener('error', this.onError);
      this.motion.removeEventListener('change', this.onUpdate);
      document.removeEventListener('visibilitychange', this.onUpdate);
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yds-olivia-scene-pair"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.ydsOliviaSceneReveal) {
    window.ydsOliviaSceneReveal.init(document);
    return;
  }
  const active = new Map();
  const animating = new Map();
  const pendingClass = 'yds-olivia-scene--reveal-pending';
  const revealClass = 'yds-olivia-scene--revealed';
  const selector = '[data-olivia-scene]';
  const elements = scope => [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
  function init(scope) {
    elements(scope).forEach(section => {
      if (active.has(section) || animating.has(section) || section.dataset.sceneRevealed === 'true') return;
      const motion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
      if (!window.IntersectionObserver || !motion || motion.matches) return;
      const panel = section.querySelector('.yds-olivia-scene__pair');
      if (!panel) return;
      let observer;
      let timer;
      const cleanupObserver = () => {
        observer?.disconnect();
        section.removeEventListener('focusin', onFocus);
        active.delete(section);
      };
      const finishAnimation = () => {
        window.clearTimeout(timer);
        section.classList.remove(revealClass);
        section.removeEventListener('animationend', onEnd);
        motion.removeEventListener?.('change', onMotion);
        animating.delete(section);
      };
      const reveal = animate => {
        section.classList.remove(pendingClass);
        section.dataset.sceneRevealed = 'true';
        cleanupObserver();
        if (animate && !motion.matches) {
          section.classList.add(revealClass);
          section.addEventListener('animationend', onEnd);
          animating.set(section, finishAnimation);
          timer = window.setTimeout(finishAnimation, 1700);
        } else finishAnimation();
      };
      const onEnd = event => {
        if (event.animationName === 'olivia-pair-reveal' && event.target.classList.contains('yds-olivia-scene__companion')) finishAnimation();
      };
      const onMotion = () => {
        if (!motion.matches) return;
        if (active.has(section)) reveal(false);
        else finishAnimation();
      };
      const onFocus = () => reveal(false);
      try {
        observer = new IntersectionObserver(entries => {
          if (!active.has(section)) return;
          if (entries.some(entry => entry.target === panel && entry.isIntersecting && entry.intersectionRatio >= .16)) reveal(true);
        }, { threshold: .16, rootMargin: '0px 0px -6% 0px' });
        motion.addEventListener?.('change', onMotion);
        section.addEventListener('focusin', onFocus);
        active.set(section, () => reveal(false));
        observer.observe(panel);
        if (active.has(section)) section.classList.add(pendingClass);
      } catch {
        section.classList.remove(pendingClass);
        cleanupObserver();
        finishAnimation();
      }
    });
  }
  const unload = scope => {
    for (const [section, finish] of active) if (scope === section || scope.contains(section)) finish();
    for (const [section, finish] of animating) if (scope === section || scope.contains(section)) finish();
  };
  window.ydsOliviaSceneReveal = { init, unload };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => unload(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yds-retail-ui"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = () => document.querySelector('[data-yds-ui-config]');
  const money = cents => new Intl.NumberFormat(config()?.dataset.locale || 'en-NZ', {style:'currency',currency:config()?.dataset.currency || 'NZD'}).format(cents / 100);
  const optionLabel = (text, handle) => {
    if (handle === 'kia-ora-welcome-word-art-wall-decal') return text.replaceAll('97.8m high','97.8cm high');
    if (handle === 'flax-window-strike') return text.replaceAll('1.66cm high','1.66m high');
    if (handle === 'blossom-tree-fantail-wall-decal') return text.replaceAll('84.2m high','84.2cm high');
    if (handle === 'whimsical-floral-bouquet-wall-decal') return ({Small:'Small · 60 × 54 cm',Medium:'Medium · 1.2 × 1 m',Large:'Large · 1.8 × 1.7 m'})[text.trim()] || text;
    if (handle === 'bamboo-flying-tuis') return ({Regular:'Regular · birds 23–25 cm wide',Large:'Large · birds 32–35 cm wide'})[text.trim()] || text;
    return text;
  };
  const refreshLabels = section => {
    const handle = section.dataset.productHandle;
    section.querySelectorAll('.select-popout__toggle,[data-option-value]').forEach(el => {
      const walker = document.createTreeWalker(el,NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) { const next = optionLabel(node.nodeValue,handle); if (next !== node.nodeValue) node.nodeValue = next; }
    });
  };
  const refreshPair = pair => {
    const price = [...pair.querySelectorAll('[data-yds-pair-variant]')].reduce((sum,s) => sum + Number(s.selectedOptions[0]?.dataset.price || 0),0);
    const total = pair.querySelector('[data-yds-pair-total]'); if (total) total.textContent = money(price);
  };
  const refreshPack = picker => {
    const quantity = Number(picker.querySelector('select').value);
    const price = Number(picker.dataset.unitPrice) * quantity;
    picker.querySelector('[data-yds-pack-total]').textContent = money(price);
    const buttonPrice = picker.closest('.product-section')?.querySelector('[data-button-price]');
    if (buttonPrice) buttonPrice.textContent = money(price);
  };
  const addItems = async (holder, button, items) => {
    if (button.disabled) return;
    const original = button.textContent;
    const error = holder.querySelector('[data-yds-error]');
    error.textContent = ''; button.disabled = true; button.textContent = config()?.dataset.adding || 'Adding…';
    try {
      const result = await fetch(holder.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      const body = await result.json();
      if (!result.ok) throw new Error(typeof body.description === 'string' ? body.description : config()?.dataset.error);
      window.location.assign(holder.dataset.cartUrl);
    } catch (e) {
      error.textContent = e.message || config()?.dataset.error;
      button.disabled = false; button.textContent = original;
    }
  };
  const gridColumnCount = grid => {
    const computed = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length;
    return Math.max(1, computed || (window.innerWidth <= 749 ? 2 : (window.innerWidth <= 1100 ? 3 : 4)));
  };
  const positionRegularEditorials = primary => {
    const grid = primary.querySelector('[data-yds-format-grid]');
    if (!grid) return;
    const active = primary.dataset.ydsActiveFilter || 'all';
    const reviewsApp = document.getElementById('shopify-section-yds_google_reviews');
    if (reviewsApp) {
      reviewsApp.dataset.ydsEditorialBreak = '2';
      reviewsApp.dataset.ydsEditorialView = 'all';
    }
    const editorials = [...grid.querySelectorAll('[data-yds-editorial-break]')];
    if (reviewsApp && !editorials.includes(reviewsApp)) editorials.push(reviewsApp);
    editorials.sort((a,b) => Number(a.dataset.ydsEditorialBreak) - Number(b.dataset.ydsEditorialBreak));
    if (active !== 'all') {
      editorials.forEach(editorial => editorial.hidden = true);
      return;
    }
    const items = [...grid.querySelectorAll('[data-yds-filter-item]')].filter(item => !item.hidden);
    const stride = gridColumnCount(grid) * 3;
    editorials.forEach(editorial => {
      const breakIndex = Number(editorial.dataset.ydsEditorialBreak || 0);
      const afterCount = stride * breakIndex;
      if (breakIndex > 0 && afterCount <= items.length) {
        items[afterCount - 1].after(editorial);
        editorial.hidden = false;
      } else {
        editorial.hidden = true;
      }
    });
  };
  const positionMuralInstall = primary => {
    const grid = primary.querySelector('[data-yds-format-grid]');
    const install = primary.querySelector('[data-yds-mural-install]');
    if (!grid || !install) return;
    const active = primary.dataset.ydsActiveFilter || 'all';
    if (active !== 'mural-dots') { install.hidden = true; return; }
    const visibleItems = [...grid.querySelectorAll('[data-yds-filter-item]')].filter(item => !item.hidden);
    const afterCount = Math.min(visibleItems.length, gridColumnCount(grid) * 3);
    if (afterCount > 0) {
      visibleItems[afterCount - 1].after(install);
      install.hidden = false;
      install.querySelectorAll('[data-yds-youtube-embed]').forEach(frame => {
        if (!frame.getAttribute('src') && frame.dataset.src) frame.setAttribute('src', frame.dataset.src);
      });
    } else install.hidden = true;
  };
  const initFormatFilters = root => {
    const primaries = root.querySelectorAll('[data-yds-filter-primary="true"][data-yds-filter-group]');
    primaries.forEach(primary => {
      if (primary.dataset.ydsFormatReady) return;
      primary.dataset.ydsFormatReady = 'true';
      primary.dataset.ydsActiveFilter = 'all';
      const group = primary.dataset.ydsFilterGroup;
      const grid = primary.querySelector('[data-yds-format-grid]');
      if (!grid || !group) return;
      const sections = [...document.querySelectorAll(`.yds-merch[data-yds-filter-group="${CSS.escape(group)}"]`)];
      sections.forEach(section => {
        if (section === primary) return;
        section.querySelectorAll('[data-yds-filter-item]').forEach(item => grid.appendChild(item));
        section.hidden = true;
      });
      const items = [...grid.querySelectorAll('[data-yds-filter-item]')];
      const controls = primary.querySelector('[data-yds-format-controls]');
      if (!controls) { positionRegularEditorials(primary); return; }
      controls.querySelectorAll('[data-yds-format-filter]').forEach(button => {
        const value = button.dataset.ydsFormatFilter;
        if (value !== 'all' && !items.some(item => item.dataset.ydsFormat === value)) button.hidden = true;
        button.addEventListener('click', () => {
          controls.querySelectorAll('[data-yds-format-filter]').forEach(other => {
            const active = other === button;
            other.classList.toggle('is-active', active);
            other.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          items.forEach(item => { item.hidden = value !== 'all' && item.dataset.ydsFormat !== value; });
          primary.dataset.ydsActiveFilter = value;
          positionRegularEditorials(primary);
          positionMuralInstall(primary);
        });
      });
      positionRegularEditorials(primary);
      positionMuralInstall(primary);
    });
  };
  const init = root => {
    initFormatFilters(root);
    root.querySelectorAll('[data-yds-pair]').forEach(refreshPair);
    root.querySelectorAll('[data-yds-pack-picker]').forEach(refreshPack);
    root.querySelectorAll('[data-yds-mega-menu]').forEach(menu => {
      if (menu.dataset.ydsMegaReady) return;
      menu.dataset.ydsMegaReady = 'true';
      const positionMega = () => {
        const summary = menu.querySelector('summary');
        const dropdown = menu.querySelector('.yds-shop-dropdown');
        if (!summary || !dropdown) return;
        dropdown.style.setProperty('--yds-mega-top', `${Math.round(summary.getBoundingClientRect().bottom)}px`);
      };
      menu.addEventListener('toggle', () => { if (menu.open) requestAnimationFrame(positionMega); });
      menu._ydsPositionMega = positionMega;
    });
    root.querySelectorAll('.yds-audited').forEach(section => {
      if (section.dataset.ydsObserved) return;
      section.dataset.ydsObserved = 'true'; refreshLabels(section);
      const observer = new MutationObserver(() => refreshLabels(section));
      section.querySelectorAll('.select-popout__toggle,[data-option-value]').forEach(el => observer.observe(el,{childList:true,subtree:true,characterData:true}));
    });
  };
  document.addEventListener('theme:variant:change',event => {
    const section = event.target.closest?.('.yds-audited');
    const variantId = event.detail?.variant?.id;
    if (!section || !variantId) return;
    document.querySelectorAll('[data-yds-pair-variant]').forEach(select => {
      if (select.dataset.ydsProductHandle !== section.dataset.productHandle) return;
      if (![...select.options].some(option => option.value === String(variantId))) return;
      select.value = String(variantId);
      refreshPair(select.closest('[data-yds-pair]'));
    });
  });
  document.addEventListener('change',event => {
    const pair = event.target.closest('[data-yds-pair]'); if (pair) refreshPair(pair);
    const pack = event.target.closest('[data-yds-pack-picker]'); if (pack) refreshPack(pack);
  });
  document.addEventListener('click',event => {
    const inlinePlay = event.target.closest('[data-yds-inline-video-play]');
    if (inlinePlay) {
      const holder = inlinePlay.closest('[data-yds-inline-video]');
      const video = holder?.querySelector('video');
      if (video) {
        holder.classList.add('is-playing');
        video.controls = true;
        const playPromise = video.play();
        if (playPromise?.catch) playPromise.catch(() => { holder.classList.remove('is-playing'); });
      }
    }
    const pairButton = event.target.closest('[data-yds-pair-add]');
    if (pairButton) { const pair = pairButton.closest('[data-yds-pair]'); addItems(pair,pairButton,[...pair.querySelectorAll('[data-yds-pair-variant]')].map(s => ({id:s.value,quantity:1}))); }
    const cartButton = event.target.closest('[data-yds-cart-add]');
    if (cartButton) { const holder = cartButton.closest('[data-yds-cart-cross-sell]'); addItems(holder,cartButton,[{id:holder.querySelector('[data-yds-cart-variant]').value,quantity:1}]); }
    const sizeLink = event.target.closest('a[href^="#yds-details-"]');
    if (sizeLink) { const detail = document.getElementById(sizeLink.hash.slice(1))?.querySelector('details'); if (detail) detail.open = true; }
    document.querySelectorAll('.yds-shop-menu[open]').forEach(menu => {if (!menu.contains(event.target)) menu.open = false;});
  });
  document.addEventListener('keydown',event => {if (event.key === 'Escape') document.querySelectorAll('.yds-shop-menu[open]').forEach(menu => {menu.open=false;menu.querySelector('summary').focus();});});
  const repositionMegaMenus = () => document.querySelectorAll('[data-yds-mega-menu][open]').forEach(menu => menu._ydsPositionMega?.());
  const repositionCollectionEditorials = () => document.querySelectorAll('[data-yds-filter-primary="true"]').forEach(primary => {
    positionRegularEditorials(primary);
    positionMuralInstall(primary);
  });
  window.addEventListener('resize',()=>{repositionMegaMenus();repositionCollectionEditorials();},{passive:true});
  window.addEventListener('scroll',repositionMegaMenus,{passive:true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init(document)); else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yds-ripple-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yds-ripple-nav')) {
  class YdsRippleNav extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.menu = this.closest('[data-yds-ripple-menu]');
      this.trigger = this.menu?.querySelector(':scope > summary');
      this.dropdown = this.querySelector('.yds-ripple-dropdown');
      this.tabs = [...this.querySelectorAll('[data-yds-ripple-tab]')];
      this.panels = [...this.querySelectorAll('[data-yds-ripple-panel]')];
      if (!this.menu || !this.trigger || !this.dropdown || !this.tabs.length || this.tabs.length !== this.panels.length) return;
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.finePointer = matchMedia('(hover: hover) and (pointer: fine)');
      this.frames = new Set();
      this.querySelector('.yds-ripple-tabs').setAttribute('role', 'tablist');
      this.querySelector('.yds-ripple-tabs').setAttribute('aria-orientation', 'vertical');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', this.panels[index].id);
        this.panels[index].setAttribute('role', 'tabpanel');
        tab.addEventListener('click', event => {
          event.preventDefault();
          this.activate(index, false, true);
        }, {signal: this.signal});
        tab.addEventListener('keydown', event => {
          const visible = this.tabs.map((item, i) => item.hidden ? -1 : i).filter(i => i >= 0);
          const current = visible.indexOf(index);
          let next;
          if (event.key === 'ArrowDown') next = visible[(current + 1) % visible.length];
          if (event.key === 'ArrowUp') next = visible[(current - 1 + visible.length) % visible.length];
          if (event.key === 'Home') next = visible[0];
          if (event.key === 'End') next = visible[visible.length - 1];
          if (next !== undefined) {
            event.preventDefault();
            this.activate(next, true, true);
          } else if (event.key === ' ') {
            event.preventDefault();
            this.activate(index, false, true);
          }
        }, {signal: this.signal});
      });
      this.artistTrigger = this.querySelector('[data-yds-open-artists]');
      this.artistPanel = this.querySelector('[data-yds-artist-panel]');
      if (this.artistTrigger && this.artistPanel) {
        this.artistTrigger.setAttribute('aria-controls', this.artistPanel.id);
        this.artistTrigger.setAttribute('aria-expanded', 'false');
        this.artistTrigger.setAttribute('role', 'button');
        this.artistTrigger.addEventListener('click', event => {
          event.preventDefault();
          const expanded = this.artistTrigger.getAttribute('aria-expanded') !== 'true';
          this.artistTrigger.setAttribute('aria-expanded', String(expanded));
          this.artistPanel.hidden = !expanded;
          this.artistPanel.closest('.yds-ripple-more').classList.toggle('yds-ripple-more--artists', expanded);
          if (expanded && !this.motion.matches) this.artistPanel.animate([{opacity:0,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],{duration:210,easing:'ease-out'});
        }, {signal:this.signal});
        this.artistTrigger.addEventListener('keydown', event => {
          if (event.key === ' ') { event.preventDefault(); this.artistTrigger.click(); }
        }, {signal:this.signal});
      }
      this.defaultIndex = this.tabs.findIndex(tab => tab.dataset.ydsRippleTab === this.dataset.default);
      if (this.defaultIndex < 0) this.defaultIndex = 0;
      this.activate(this.defaultIndex, false, false);
      this.querySelector('[data-yds-open-wall]')?.addEventListener('click', () => {
        const index = this.tabs.findIndex(tab => tab.dataset.ydsRippleTab === 'wall');
        if (index >= 0) this.activate(index, true, true);
      }, {signal: this.signal});
      this.menu.classList.add('yds-ripple-enhanced');
      this.trigger.setAttribute('aria-expanded', String(this.menu.open));
      this.trigger.addEventListener('click', event => {
        this.clearTimers();
        if (!this.menu.open) this.activate(this.defaultIndex, false, false);
        if (this.menu.open && this.openedByHover) {
          event.preventDefault();
          this.openedByHover = false;
        }
        this.position();
      }, {signal: this.signal});
      this.trigger.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.open(false);
          this.tabs.find(tab => !tab.hidden)?.focus();
        }
      }, {signal: this.signal});
      this.menu.addEventListener('toggle', () => {
        this.restartNewBadge();
        this.trigger.setAttribute('aria-expanded', String(this.menu.open));
        if (this.menu.open) {
          document.querySelectorAll('.yds-shop-menu[open]').forEach(other => { if (other !== this.menu) other.open = false; });
          this.position();
        } else {
          this.openedByHover = false;
          this.clearTimers();
        }
      }, {signal: this.signal});
      this.menu.addEventListener('pointerenter', event => {
        if (!this.finePointer.matches || event.pointerType === 'touch') return;
        clearTimeout(this.closeTimer);
        if (!this.menu.open) this.openTimer = setTimeout(() => this.open(true), 140);
      }, {signal: this.signal});
      this.menu.addEventListener('pointerleave', event => {
        if (!this.finePointer.matches || event.pointerType === 'touch') return;
        clearTimeout(this.openTimer);
        this.closeTimer = setTimeout(() => {
          if (!this.menu.contains(document.activeElement)) this.menu.open = false;
        }, 330);
      }, {signal: this.signal});
      this.dropdown.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), {signal: this.signal});
      this.menu.addEventListener('focusout', () => {
        this.queue(() => {
          if (!this.menu.contains(document.activeElement)) this.menu.open = false;
        });
      }, {signal: this.signal});
      document.addEventListener('click', event => {
        if (this.menu.open && !this.menu.contains(event.target)) this.menu.open = false;
      }, {signal: this.signal});
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.menu.open) {
          this.menu.open = false;
          this.trigger.focus();
        }
      }, {signal: this.signal});
      document.addEventListener('toggle', event => {
        if (event.target !== this.menu && event.target.matches?.('.yds-shop-menu[open]')) this.menu.open = false;
      }, {capture: true, signal: this.signal});
      window.addEventListener('resize', () => {
        if (!this.menu.getClientRects().length || !this.trigger.getClientRects().length) this.menu.open = false;
        this.schedulePosition();
      }, {passive: true, signal: this.signal});
      window.addEventListener('scroll', () => this.schedulePosition(), {passive: true, signal: this.signal});
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.schedulePosition());
        this.observer.observe(this.menu.closest('.theme__header') || this.menu.closest('[data-header-wrapper]') || this.trigger);
      }
    }
    activate(index, focus, animate) {
      const selectedTabWasFocused = document.activeElement === this.tabs[index];
      this.activeIndex = index;
      const overview = this.tabs[index].dataset.ydsRippleTab === 'more';
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.hidden = overview && tab.dataset.ydsRippleTab === 'more';
        tab.tabIndex = selected && !tab.hidden ? 0 : -1;
        this.panels[i].hidden = !selected;
      });
      if (overview) this.tabs.find(tab => !tab.hidden).tabIndex = 0;
      this.restartNewBadge();
      if (focus || (overview && selectedTabWasFocused)) {
        (overview ? this.tabs.find(tab => !tab.hidden) : this.tabs[index]).focus();
      }
      if (animate && !this.motion.matches) {
        const panel = this.panels[index];
        panel.getAnimations().forEach(animation => animation.cancel());
        panel.animate([{opacity: 0, transform: 'translateY(5px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 210, easing: 'ease-out'});
      }
    }
    restartNewBadge() {
      const badge = this.querySelector('[data-yds-ripple-panel="wall"] .yds-ripple-link__new');
      if (!badge) return;
      badge.style.animation = 'none';
      void badge.offsetWidth;
      if (this.menu.open) badge.style.removeProperty('animation');
    }
    queue(callback) {
      const frame = requestAnimationFrame(() => { this.frames.delete(frame); callback(); });
      this.frames.add(frame);
    }
    clearTimers() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
    }
    open(hover) {
      this.clearTimers();
      if (!this.menu.open) {
        this.openedByHover = hover;
        this.activate(this.defaultIndex, false, false);
      }
      this.position();
      this.menu.open = true;
    }
    schedulePosition() {
      if (!this.menu.open || this.positionQueued) return;
      this.positionQueued = true;
      this.queue(() => { this.positionQueued = false; this.position(); });
    }
    position() {
      const header = this.menu.closest('.theme__header') || this.menu.closest('[data-header-wrapper]');
      const triggerRect = this.trigger.getBoundingClientRect();
      const headerRect = header?.getBoundingClientRect();
      const bottom = Math.max(triggerRect.bottom, headerRect?.bottom || 0);
      const top = Math.max(0, Math.min(Math.round(bottom), window.innerHeight - 100));
      this.dropdown.style.setProperty('--yds-ripple-top', `${top}px`);
    }
    disconnectedCallback() {
      this.clearTimers();
      this.controller?.abort();
      this.observer?.disconnect();
      this.frames?.forEach(frame => cancelAnimationFrame(frame));
      this.controller = null;
    }
  }
  customElements.define('yds-ripple-nav', YdsRippleNav);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yds-story-behaviour"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(root=document) {
    root.querySelectorAll('[data-y2-film]').forEach(hero => {
      if (hero.dataset.ready) return;
      hero.dataset.ready='true';
      const video=hero.querySelector('video'),button=hero.querySelector('[data-film-control]');
      if(!video||!button)return;
      button.hidden=false;
      if(hero.clientWidth<600&&hero.dataset.mobileSource)video.src=hero.dataset.mobileSource;
      const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      let requested=!reduced.matches&&!navigator.connection?.saveData;
      function label(){button.textContent=video.paused?button.dataset.play:button.dataset.pause;button.setAttribute('aria-label',button.textContent)}
      function play(){video.muted=true;video.play().catch(()=>{label()})}
      video.addEventListener('playing',()=>{hero.setAttribute('data-playing','');label()});
      video.addEventListener('pause',label);
      button.addEventListener('click',()=>{requested=video.paused;if(requested)play();else video.pause()});
      reduced.addEventListener('change',()=>{if(reduced.matches){requested=false;video.pause()}});
      new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting&&requested)play();else video.pause()})},{threshold:.08}).observe(hero);
      document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause()});
    });
    root.querySelectorAll('[data-y2-products]').forEach(section=>{
      if(section.dataset.ready)return;section.dataset.ready='true';
      const rail=section.querySelector('[data-product-rail]'),prev=section.querySelector('[data-prev]'),next=section.querySelector('[data-next]');
      if(!rail||!prev||!next)return;
      function state(){prev.disabled=rail.scrollLeft<3;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-3}
      const move=direction=>rail.scrollBy({left:direction*rail.clientWidth*.94,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));rail.addEventListener('scroll',state,{passive:true});new ResizeObserver(state).observe(rail);state();
    });
    root.querySelectorAll('.y2-header details').forEach(menu=>{
      if(menu.dataset.ready)return;menu.dataset.ready='true';
      menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.open=false;menu.querySelector('summary').focus()}});
      menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{menu.open=false}));
      document.addEventListener('click',e=>{if(menu.open&&!menu.contains(e.target))menu.open=false});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yds-story-style"] && !Shopify.designMode) return;
  try {
    (() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (scope = document) => {
    if (!('IntersectionObserver' in window) || motion.matches) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (motion.matches) return;
        entry.target.animate([
          { opacity: 0.1, transform: 'translateY(16px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 650, easing: 'cubic-bezier(.2,.65,.2,1)' });
      });
    }, { threshold: 0.12 });
    scope.querySelectorAll('.ys-main [data-ys-reveal]').forEach(el => {
      if (el.dataset.ysReady) return;
      el.dataset.ysReady = 'true';
      observer.observe(el);
    });
  };
  motion.addEventListener('change', () => {
    if (motion.matches) document.querySelectorAll('.ys-main [data-ys-reveal]').forEach(el => el.getAnimations().forEach(animation => animation.cancel()));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', () => init());
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yds-story-video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const button = event.target.closest('[data-ys-play]');
  if (!button) return;
  const video = button.closest('[data-ys-video]');
  const frame = video.querySelector('.ys-video-frame');
  const source = video.querySelector('[data-ys-player]');
  if (!source || !frame) return;
  frame.replaceChildren(source.content.cloneNode(true));
  video.classList.add('is-playing');
  frame.querySelector('iframe')?.focus();
});
  } catch(e) { console.error(e); }
})();

})();
